import { apiClient } from './apiClient';

import type { ApiResponse } from '@/types/auth.types';
import type { PromptSet, PromptSetFormData } from '@/types/promptSet.types';

interface PromptSetListData {
  items: PromptSet[];
}

export async function listPromptSets(): Promise<PromptSet[]> {
  const response = await apiClient.get<ApiResponse<PromptSetListData>>('/prompt-sets');
  return response.data.items;
}

export async function createPromptSet(data: PromptSetFormData): Promise<PromptSet> {
  const response = await apiClient.post<ApiResponse<PromptSet>>('/prompt-sets', data);
  return response.data;
}

export async function updatePromptSet(id: string, data: Partial<PromptSetFormData>): Promise<PromptSet> {
  const response = await apiClient.put<ApiResponse<PromptSet>>(`/prompt-sets/${id}`, data);
  return response.data;
}

interface AvatarUploadUrlResponse {
  uploadUrl: string;
  fileKey: string;
  expiresInSeconds: number;
}

export async function getAvatarUploadUrl(
  promptSetId: string,
  promptIndex: number,
  contentType: string,
): Promise<AvatarUploadUrlResponse> {
  const response = await apiClient.post<ApiResponse<AvatarUploadUrlResponse>>(
    `/prompt-sets/${promptSetId}/prompts/${promptIndex}/upload-url`,
    { contentType },
  );
  return response.data;
}

export async function confirmAvatarUpload(
  promptSetId: string,
  promptIndex: number,
  fileKey: string,
  durationSec: number,
): Promise<PromptSet> {
  const response = await apiClient.post<ApiResponse<PromptSet>>(
    `/prompt-sets/${promptSetId}/prompts/${promptIndex}/confirm-upload`,
    { fileKey, durationSec },
  );
  return response.data;
}
